import { render } from "./AllocationGrid.vue?vue&type=template&id=52ba42cb&scoped=true"
import script from "./AllocationGrid.vue?vue&type=script&lang=js"
export * from "./AllocationGrid.vue?vue&type=script&lang=js"

import "./AllocationGrid.vue?vue&type=style&index=0&id=52ba42cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52ba42cb"]])

export default __exports__